import { render, staticRenderFns } from "./globalcounters.vue?vue&type=template&id=d3374ccc"
import script from "./globalcounters.vue?vue&type=script&lang=js"
export * from "./globalcounters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports